import { css } from 'styled-components';
import { useStyle } from '@utils/styles/styles';

export const usePaddingTop = useStyle(
  () => css`
    padding-top: 70px;
  `
);
